export default function authHeader() {
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.authorisation) {
    return { Authorization: 'Bearer ' + user.authorisation.token };
  } else {
    return {};
  }
}